export const environment = {
  production: true,
  APIURL: 'https://jdportfolio.onrender.com'
};